import styled, { css } from 'styled-components';

export const StyledSotyBadge = styled.div`
  display: flex;
  justify-content: center;
`;

type ImageWrapperProps = {
  size: number;
};

export const StyledImageWrapper = styled.div<ImageWrapperProps>(
  props => css`
    width: ${`${props.size}px`};
  `
);
